import React from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import logo from "../../assets/images/logo192.PROD.png"


interface IWithAuthenticatedTemplateManagerProps {
  children: React.ReactNode;
}

const AuthenticatedTemplateManager: React.FunctionComponent<IWithAuthenticatedTemplateManagerProps> = ({
  children,
}) => {

  if (!navigator.onLine) {
    return <UnauthenticatedTemplate>{children}</UnauthenticatedTemplate>;
  }

  return (
    <>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
      <section className="unauth_error">
        <img src={logo} alt="" />
        <p>Nous n'avons pas pu vous identifier, redirection vers la page de connexion...</p>
        <button className="unauth_error__btn" onClick={()=> window.location.reload()}>recharger la page</button>
        </section>
      </UnauthenticatedTemplate>
    </>
  );
};

export default AuthenticatedTemplateManager;
